import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, IconButton, Typography } from '@mui/material'
import React from 'react'
import { useAccessibility } from '../../../Store/contexts/AccessibilityContext'
import { TokenRegisterType } from '../../../interfaces/enum/TokenRegisterType'
import { OptionsRegisterProps } from '../../../interfaces/props/register/OptionsRegisterProps'
import { sxButtonOptionRecovery, sxTypographyTitle } from '../sxProps'

const OptionsTokenRegister: React.FC<OptionsRegisterProps> = ({ formBack, openTokenReceived, email, cel }) => {

  const { textStyleAccessibility, buttonStyleAccessibility, buttonTextStyleAccessibility } = useAccessibility();
  return (
    <div style={textStyleAccessibility} className='width-100 flex-gap-16'>
      <div className='password-recovery-container-text'>
        <div className='width-100'>
          <IconButton onClick={() => formBack()} type="button">
            <FontAwesomeIcon style={textStyleAccessibility} icon={faArrowLeft} />
          </IconButton>
          <Typography style={textStyleAccessibility} sx={sxTypographyTitle} className='margin-bottom-painel-rigth'>Definir senha</Typography>
        </div>
        <div className='container-text-recovery '>
          <span style={textStyleAccessibility} className='login-text login-text-center'>Escolha abaixo por onde quer receber o seu token de acesso para o canal do cliente.</span>
        </div>
      </div>
      <div className='container-recovery-password-options'>
        <Button style={buttonStyleAccessibility} sx={sxButtonOptionRecovery}
          onClick={() => openTokenReceived(TokenRegisterType.Email)} variant='contained'
          disabled={!email}
        >
          <Typography style={buttonTextStyleAccessibility}>RECEBER TOKEN POR EMAIL</Typography>
        </Button>
        <Button style={buttonStyleAccessibility} sx={sxButtonOptionRecovery}
          onClick={() => openTokenReceived(TokenRegisterType.SMS)} variant='contained'
          disabled={!cel}
        >
          <Typography style={buttonTextStyleAccessibility}>RECEBER TOKEN POR SMS</Typography>
        </Button>
      </div>
    </div>
  )
}

export default OptionsTokenRegister